import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import {
  MB_CHECKOUT_REVIEW_PRICES_NORMALIZER,
  MbCheckoutReviewPricesAdapter
} from '../connectors/review-prices'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Injectable({
  providedIn: 'root',
})
export class MbOccCheckoutReviewPricesAdapter implements MbCheckoutReviewPricesAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService,
              protected activeCartService: ActiveCartService) { }

  load (cartId: string) {
    return this.http.get(this.getEndpoint(cartId)).pipe(
      this.converter.pipeable(MB_CHECKOUT_REVIEW_PRICES_NORMALIZER)
    )
  }

  protected getEndpoint (cartId: string) {
    return this.occEndpoints.buildUrl(
      'checkoutReviewPrices',
      {
        urlParams: { cartId },
      }
    )
  }
}
